// source: pbtypes/gen/planner/movement_waypoint.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_eigen_lcm_Vector3d_pb = require('../../../pbtypes/gen/eigen_lcm/Vector3d_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector3d_pb);
var pbtypes_gen_uuid_util_uuid_pb = require('../../../pbtypes/gen/uuid_util/uuid_pb.js');
goog.object.extend(proto, pbtypes_gen_uuid_util_uuid_pb);
goog.exportSymbol('proto.planner.MovementWaypoint', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.planner.MovementWaypoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.planner.MovementWaypoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.planner.MovementWaypoint.displayName = 'proto.planner.MovementWaypoint';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.planner.MovementWaypoint.prototype.toObject = function(opt_includeInstance) {
  return proto.planner.MovementWaypoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.planner.MovementWaypoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.planner.MovementWaypoint.toObject = function(includeInstance, msg) {
  var f, obj = {
speed: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
maxPathSpeed: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
position: (f = msg.getPosition()) && pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.toObject(includeInstance, f),
uuid: (f = msg.getUuid()) && pbtypes_gen_uuid_util_uuid_pb.Uuid.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.planner.MovementWaypoint}
 */
proto.planner.MovementWaypoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.planner.MovementWaypoint;
  return proto.planner.MovementWaypoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.planner.MovementWaypoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.planner.MovementWaypoint}
 */
proto.planner.MovementWaypoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSpeed(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxPathSpeed(value);
      break;
    case 3:
      var value = new pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.deserializeBinaryFromReader);
      msg.setPosition(value);
      break;
    case 4:
      var value = new pbtypes_gen_uuid_util_uuid_pb.Uuid;
      reader.readMessage(value,pbtypes_gen_uuid_util_uuid_pb.Uuid.deserializeBinaryFromReader);
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.planner.MovementWaypoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.planner.MovementWaypoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.planner.MovementWaypoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.planner.MovementWaypoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSpeed();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getMaxPathSpeed();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getPosition();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.serializeBinaryToWriter
    );
  }
  f = message.getUuid();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      pbtypes_gen_uuid_util_uuid_pb.Uuid.serializeBinaryToWriter
    );
  }
};


/**
 * optional double speed = 1;
 * @return {number}
 */
proto.planner.MovementWaypoint.prototype.getSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.MovementWaypoint} returns this
 */
proto.planner.MovementWaypoint.prototype.setSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double max_path_speed = 2;
 * @return {number}
 */
proto.planner.MovementWaypoint.prototype.getMaxPathSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.MovementWaypoint} returns this
 */
proto.planner.MovementWaypoint.prototype.setMaxPathSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional eigen_lcm.Vector3dPb position = 3;
 * @return {?proto.eigen_lcm.Vector3dPb}
 */
proto.planner.MovementWaypoint.prototype.getPosition = function() {
  return /** @type{?proto.eigen_lcm.Vector3dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb, 3));
};


/**
 * @param {?proto.eigen_lcm.Vector3dPb|undefined} value
 * @return {!proto.planner.MovementWaypoint} returns this
*/
proto.planner.MovementWaypoint.prototype.setPosition = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.planner.MovementWaypoint} returns this
 */
proto.planner.MovementWaypoint.prototype.clearPosition = function() {
  return this.setPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.planner.MovementWaypoint.prototype.hasPosition = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional uuid_util.Uuid uuid = 4;
 * @return {?proto.uuid_util.Uuid}
 */
proto.planner.MovementWaypoint.prototype.getUuid = function() {
  return /** @type{?proto.uuid_util.Uuid} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_uuid_util_uuid_pb.Uuid, 4));
};


/**
 * @param {?proto.uuid_util.Uuid|undefined} value
 * @return {!proto.planner.MovementWaypoint} returns this
*/
proto.planner.MovementWaypoint.prototype.setUuid = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.planner.MovementWaypoint} returns this
 */
proto.planner.MovementWaypoint.prototype.clearUuid = function() {
  return this.setUuid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.planner.MovementWaypoint.prototype.hasUuid = function() {
  return jspb.Message.getField(this, 4) != null;
};


goog.object.extend(exports, proto.planner);
